module.exports = __webpack_public_path__ + "img/img-gallery-5.89fe7c0d.jpg";